import { getGroupFolder } from './getGroupFolder';

function addAllChildFoldersToList(allFolderIdsList: string[], groupId: string, folderId: string) {
    const groupFolder = getGroupFolder(groupId, folderId);
    groupFolder?.ChildFolderIds?.forEach(folderId => {
        allFolderIdsList.push(folderId);
        addAllChildFoldersToList(allFolderIdsList, groupId, folderId);
    });
}

/**
 * @param groupId Smtp address of the group
 * @param folderId Folder Id of the group folder
 * @returns List of all the sub folders under the specified group folder
 */
export function getAllSubFolderIds(groupId: string, folderId: string): string[] {
    let allFolderIdsList: string[] = [];

    if (groupId && folderId) {
        const groupFolder = getGroupFolder(groupId, folderId);
        groupFolder?.ChildFolderIds?.forEach(folderId => {
            allFolderIdsList.push(folderId);
            addAllChildFoldersToList(allFolderIdsList, groupId, folderId);
        });
    }
    return allFolderIdsList;
}
